export default __webpack_public_path__ + "ui.6bcad6ab.png";